import React, { useRef ,useEffect } from 'react'
import { Grid } from '@material-ui/core'
import { PushToTalkButtonContainer, PushToTalkButton, ErrorPanel } from '@speechly/react-ui'
import { SpeechState, useSpeechContext } from '@speechly/react-client'
import Details from './components/Details/Details'
import Main from './components/Main/Main'
import useStyles from './styles'

function App() {
  const classes = useStyles()
  const main = useRef(null)
  const { speechState } = useSpeechContext()

  const executeScroll = () => main.current.scrollIntoView()
 
  useEffect(() => {
    if(speechState === SpeechState.Recording){
      executeScroll()
    }
  },[speechState])

  return (
    <div className="App">
      <Grid className={classes.grid} container spacing={0} alignItems='center' justifyContent='center' style={{height: '100vh'}}> 
        
        <Grid item xs={12} sm={3} className={classes.mobile}>
          <Details title='income' />
        </Grid>

        <Grid ref={main} item xs={12} sm={3} className={classes.main}>
          <Main />
        </Grid>

        <Grid item xs={12} sm={3} className={classes.desktop}>
          <Details title='income' />
        </Grid>

        <Grid item xs={12} sm={3} className={classes.last}>
          <Details title='expense' />
        </Grid>
      </Grid>
      
      <PushToTalkButtonContainer>
        <PushToTalkButton />
        <ErrorPanel />
      </PushToTalkButtonContainer>
      
      
    </div>
  );
}

export default App;
